var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNeherlab = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 354.325 354.325"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#231f20",
  stroke: "#cd5c5c",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 8.75,
  d: "m271.871 83.115 28.387-11.401"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#6d6e70",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.25,
  d: "M262.911 306.125c-.232.27-9.406 7.882-22.362 15.762m-.327.191 7.635 13.27"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#231f20",
  stroke: "#cd5c5c",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 8.75,
  d: "m236.296 130.905 26.995-19.264m.429-.707 17.658-60.26m-17.658 60.26 25.11 2.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#231f20",
  stroke: "#5097ba",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 8.75,
  d: "m308.295 83.115-19.465 30.319"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#231f20",
  stroke: "#cd5c5c",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 8.976,
  d: "m301.33 122.29-13.093-9.095"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#231f20",
  stroke: "#cd5c5c",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 8.75,
  d: "m305.582 122.255 13.679-22.131m-17.816 22.28 26.305 6.049"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#cd5c5c",
  d: "M100.64 230.164c19.209-13.047 22.304-37.72 23.194-58.99.566-13.543-.109-27.885 2.804-41.178.917-4.185 4.008-13.565 9.338-8.372 3.254 3.17 4.183 9.11 5.154 13.335 5.04 21.917 1.498 49.3 20.929 64.94 8.404 6.763 19.77 6.886 30.045 6.74 12.874-.183 25.724-1.122 38.597-1.194 6.044-.035 6.048-9.41 0-9.375-12.87.072-25.73.925-38.597 1.195-13.019.271-23.714-.998-31.188-12.754-6.8-10.696-6.598-25.165-8.21-37.346-1.322-9.99-2.496-22.949-9.207-31.086-5.541-6.72-14.63-7.424-20.39-.628-7.336 8.655-7.12 22.171-7.725 32.813-1.318 23.19 2.952 58.573-19.475 73.803-4.97 3.377-.285 11.504 4.731 8.097"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#cd5c5c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 8.75,
  d: "m221.223 189.058 11.784 11.782-11.784 11.783"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#6d6e70",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.25,
  d: "m263.447 305.674 9.965 12.231"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#6d6e70",
  strokeMiterlimit: 10,
  strokeWidth: 10,
  d: "M248.214 180.23c0 50.176-40.676 90.852-90.852 90.852S66.51 230.406 66.51 180.229c0-50.175 40.675-90.85 90.852-90.85 50.176 0 90.852 40.675 90.852 90.85z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#6d6e70",
  strokeMiterlimit: 10,
  strokeWidth: 6.25,
  d: "M81.11 91.363c0 5.47-4.434 9.905-9.904 9.905S61.3 96.833 61.3 91.363s4.435-9.905 9.905-9.905 9.905 4.435 9.905 9.905zm55.385-31.854c0 5.47-4.433 9.905-9.905 9.905-5.47 0-9.905-4.435-9.905-9.905s4.435-9.905 9.905-9.905c5.472 0 9.905 4.435 9.905 9.905zm-89.038 86.884c0 5.47-4.435 9.905-9.905 9.905s-9.905-4.435-9.905-9.905 4.435-9.905 9.905-9.905 9.905 4.435 9.905 9.905zm1.25 68.724c0 5.471-4.435 9.905-9.905 9.905s-9.905-4.434-9.905-9.905c0-5.469 4.435-9.905 9.905-9.905s9.905 4.436 9.905 9.905zm30.428 52.288c0 5.469-4.434 9.902-9.906 9.902-5.47 0-9.904-4.433-9.904-9.902 0-5.471 4.434-9.908 9.904-9.908 5.472 0 9.906 4.437 9.906 9.908zm63.54 33.833c0 5.469-4.435 9.902-9.905 9.902s-9.905-4.433-9.905-9.902c0-5.471 4.435-9.908 9.905-9.908s9.905 4.437 9.905 9.908z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#6d6e70",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.25,
  d: "m128.948 69.12 5.483 21.647m-56.229 7.607 15.547 15.703m110.439 145.769 7.273 12.439M47.047 149.201l22.16 6.471M48.301 212.33l20.82-6.483m7.468 54.934 15.927-16.001m42.895 46.917 4.395-22.313"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#6d6e70",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.25,
  d: "M226.675 262.158c-15.784 11.604-15.557 11.179-32.208 18.394m58.947-5.892s-7.311 7.586-18.658 15.242m67.584-70.415 28.44 7.628m-43.596 27.778 25.762 15.153m-85.977-7.888 17.399 20.608m9.388-7.764 31.415 31.414m-50.415-16.514 16.802 24.104m-57.09-33.454 24.829 68.217m26.43-288.852 17.993-23.724m-55.945 3.867s24.59 9.05 37.57 19.98m-37.401-20.494 10.008-27.52m-7.578 68.742L227.6 48.815m-50.662 19.637 11.477-64.341m-11.477 65.083s18.221 3.087 33.217 11.574"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#6d6e70",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.25,
  d: "m187.737 94.706 7.262-20.034"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#6d6e70",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.25,
  d: "m304.66 154.25 29.574-5.44m-29.461 57.013 29.461 5.351m-56.294-31.137 28.2.1m-37.845 45.083 27.435 11.032m6.084-16.879s-5.579 21.176-14.686 35.178m-9.806-74.514s.896 21.403-9.028 45.182"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#6d6e70",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.25,
  d: "m246.797 197.94 28.107 5.69"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#6d6e70",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.25,
  d: "M304.66 154.363s4.326 32.561 0 51.345"
})));
export default SvgNeherlab;